var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "apple_svg__a",
    d: "M4 3h11.8v14H4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "apple_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#apple_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 16.4c-.8.7-1.6.6-2.4.3-.8-.4-1.6-.4-2.5 0-1.1.5-1.7.3-2.4-.3-3.8-3.9-3.2-9.8 1.1-10.1 1.1.1 1.8.6 2.4.7.9-.2 1.8-.7 2.8-.7 1.2.1 2.1.6 2.6 1.4-2.4 1.5-1.8 4.7.4 5.5-.4 1.2-1 2.4-2 3.2zM9.9 6.3c-.1-1.7 1.3-3.2 2.9-3.3.3 2-1.8 3.5-2.9 3.3z",
    style: {
      clipPath: "url(#apple_svg__b)"
    }
  }));
};
export default SvgApple;